// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
import Fullscreen from "react-full-screen";
// ANTD
import message from 'antd/lib/message';
import 'antd/lib/message/style/css';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import Row from 'components/common/Row';
import Col from 'components/common/Col';
import UnsubscribedContent from 'components/common/UnsubscribedContent';
import LinkText from 'components/text/LinkText';
import DashboardsDropdown from 'components/inputs/DashboardsDropdown';
import DashboardFrame from './DashboardFrame';
import Body from 'components/text/Body';
import { Link } from 'react-router-dom';
// lib
import constants from 'lib/constants';
// APOLLO
import customDashboardByIdQuery from 'ApolloClient/Queries/customDashboardById';
import { compose, graphql } from 'react-apollo';
import logActivity from 'ApolloClient/Mutations/logActivity';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';

const Logo = styled.img`
  height: 61px;
  margin: auto;
`;


const MenuItem = ({ label, onClick }) => (
  <LinkText onClick={onClick} style={{ textAlign: 'center' }}>
    {label}
  </LinkText>
);

const MenuArea = ({ history, onToggleFullScreen }) => (
  <Row>
    <Col xs={6}>
      <MenuItem label="Home" onClick={() => history.push('/')} />
    </Col>
    <Col xs={6}>
      <MenuItem
        label="Help"
        onClick={() => {
          let win = window.open('https://www.zendesk.com', '_blank');
          return win.focus();
        }}
      />
    </Col>
    <Col xs={6}>
      {' '}
      <MenuItem
        label="Contact"
        onClick={() => history.push('/contact')}
      />
    </Col>
    <Col xs={6}>
      <MenuItem label="Full Screen" onClick={onToggleFullScreen} />
    </Col>
  </Row>
);

class AppDashboardDetail extends React.PureComponent {
  state = {
    isFull: false
  }
  async componentDidMount(){
    await this.props.logActivity({
      variables: {
        params: {
          userId: this.props.currentUser._id,
          eventType: 'dashboardEnter',
          dashboardId: this.props.match.params.id,
          date: new Date(),
          userAgent: window.navigator.userAgent,
        },
      },
    });
  }
  async componentWillUnmount(){
    await this.props.logActivity({
      variables: {
        params: {
          userId: this.props.currentUser._id,
          eventType: 'dashboardExit',
          dashboardId: this.props.match.params.id,
          date: new Date(),
          userAgent: window.navigator.userAgent,
        },
      },
    });
  }
  onChangeDashboard = id => {
    console.log(id);
    const organization = this.getOrganization();
    this.props.history.push(`/dashboards/${id}/${organization._id}`);
  };

  getOrganization = () => {
    if (this.props.match.params.orgId) {
      let filteredOrganizations = this.props.currentUser.organizations.filter(
        org => org._id === this.props.match.params.orgId,
      );
      return filteredOrganizations[0];
    }
    return null;
  };

  render() {
    const dashboard = this.props.customDashboardByIdQuery.customDashboardById;
    const organization = this.getOrganization();
    return (
      <React.Fragment>
        <Row style={{ borderBottom: '1px solid #efefef', padding: 10 }}>
          <Col xs={5}>
            {' '}
            <Link to="/">
              <Logo src={constants.images.logoBlack} alt="cclariti" />
            </Link>
          </Col>
          <Col xs={19}>
            <Row gutter={40}>
              <Col xs={8}>
                <DashboardsDropdown
                  dashboards={organization.dashboards}
                  onChange={this.onChangeDashboard}
                  value={dashboard._id}
                />
              </Col>
              <Col xs={8}>
                <MenuArea
                  history={this.props.history}
                  onToggleFullScreen={() => this.setState({isFull: !this.state.isFull})}
                />
              </Col>
              <Col xs={8} />
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            {!this.props.currentUser.organization || !this.props.currentUser.organization.subscribed ? (
              <PageContainer>
                <UnsubscribedContent />{' '}
              </PageContainer>
            ) : (
              <Fullscreen
                enabled={this.state.isFull}
                onChange={isFull => this.setState({isFull})}
              >
                <DashboardFrame
                  filterType={dashboard.filterType}
                  reportId={dashboard.dashboardId}
                  groupId={dashboard.groupId}
                  userId={organization._id}
                  currentUser={this.props.currentUser}
                  isFull={this.state.isFull} 
                />
              </Fullscreen>
            )}
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

let options = props => ({
  variables: {
    _id: props.match.params.id,
  },
});

export default compose(
  graphql(logActivity, { name: 'logActivity'}),
  graphql(customDashboardByIdQuery, { options, name: 'customDashboardByIdQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'customDashboardByIdQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'customDashboardByIdQuery' }),
)(AppDashboardDetail);



// WEBPACK FOOTER //
// ./src/routes/app-dashboard-detail/index.js